export default __webpack_public_path__ + "static/media/socialPay.7f6df79c.svg";